import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Writing = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M.5 1.42c0-.6.5-1 1-1h32.53c.6 0 1 .5 1 1v3.2c0 .6-.5 1-1 1-.501 0-1.002-.5-1.002-1v-2.2H2.502v40h30.526v-9.1c0-.6.5-1 1.001-1 .5 0 1 .5 1 1v10.1c0 .6-.5 1-1 1H1.501c-.6 0-1.001-.5-1.001-1v-42Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M41.936 10.42c-2.102-2.1-5.605-2.1-7.707 0l-11.01 11H7.507c-.6 0-1 .5-1 1s.5 1 1 1h13.712l-7.406 7.3c-.2.2-.3.4-.4.6l-1.002 3.3H7.406c-.6 0-1 .5-1 1 0 .6.5 1 1 1h4.304c0 .1-1.001 3.3-1.101 3.5-.1.4 0 .8.2 1 .2.3.6.4 1.1.3l3.404-1 5.605-1.7c2.402-2 19.016-18.9 20.918-20.7 2.202-2 2.202-5.5.1-7.6Zm-27.023 23.1 3.903 3.8c-1.101.3-4.504 1.4-5.605 1.7l1.701-5.5Zm5.805 2.9-4.805-4.8c4.104-4.2 12.311-12.3 16.415-16.5l4.804 4.8-16.414 16.5Zm19.817-19.7-1.802 1.8-4.804-4.8 1.801-1.8c1.302-1.3 3.504-1.3 4.805 0 1.3 1.3 1.3 3.4 0 4.8ZM6.405 9.12c0-.6.5-1 1.001-1h20.618c.6 0 1 .5 1 1 0 .6-.5 1-1 1H7.506c-.6 0-1.1-.4-1.1-1Z"
  })));
});
Writing.displayName = 'Writing';
Writing.defaultProps = {
  'aria-label': 'Writing'
};
export default Writing;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Writing.js
// module id = 3332
// module chunks = 11